/* Uses GLTFLoader THREEJS example (v0.117.0) */

// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { FBXLoader } from '../../../three.examples/FBXLoader';

const THREE = require('three');

export const FBXLoadPromise = (path) => new Promise((resolve, reject) => {
    const manager = new THREE.LoadingManager();
    const loader = new FBXLoader(manager);

    loader.load(
        path,
        (object) => {
            resolve(object);
        },
        undefined,
        (e) => {
            reject(new Error(`Faild to load '${path} width error ${e}'`));
        }
    );
});
